import {useMutation, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {logout, type LogoutResponse} from '../../http';

export function useLogout(
	options?: UseMutationOptions<LogoutResponse, unknown, void>,
): UseMutationResult<LogoutResponse, unknown, void> {
	return useMutation<LogoutResponse, unknown, void>(() => logout().then(({data}) => data), options);
}
